import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { SEARCH_ENTITY_TYPE, type AdminGlobalSearchVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { searchGlobal } from "./search-global";

const initialState: RetrievalState<AdminGlobalSearchVM> = {
  fetching: "idle",
  data: { [SEARCH_ENTITY_TYPE.STUDENT]: [], [SEARCH_ENTITY_TYPE.TEACHER]: [], [SEARCH_ENTITY_TYPE.PROVIDER]: [] },
};

export const searchGlobalReducer = createReducer<RetrievalState<AdminGlobalSearchVM>>(initialState, builder => {
  builder.addCase(searchGlobal.fulfilled, (state, { payload }) => ({
    ...state,
    data: payload,
    fetching: "success",
  }));
  builder.addCase(searchGlobal.pending, state => ({
    ...state,
    fetching: "pending",
  }));
  builder.addCase(searchGlobal.rejected, state => ({
    ...state,
    fetching: "failed",
  }));
});
